import { fileServerLinkedServiceValidators } from 'shell-models-lib';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';

fileServerLinkedServiceValidators.validateAKVLinkedserviceReference = validateAKVLinkedserviceReference;
export { FileServerLinkedService } from 'shell-models-lib';
